import { render, staticRenderFns } from "./BlockList.vue?vue&type=template&id=478c60b8&scoped=true&"
import script from "./BlockList.vue?vue&type=script&lang=js&"
export * from "./BlockList.vue?vue&type=script&lang=js&"
import style0 from "./BlockList.vue?vue&type=style&index=0&id=478c60b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478c60b8",
  null
  
)

export default component.exports